<template>
  <div class="m-video-player">
    <div v-if="! consent" class="m-video-player__not-allowed">
      <button v-if="cookiebot.loaded()" type="button" @click.prevent="cookiebot.renew" class="m-video-player__not-allowed-link" v-html="$t('cookies.change_settings_to_watch_video')"></button>
      <button v-if="! cookiebot.loaded()" type="button" @click.prevent="consentOverride = true" class="m-video-player__not-allowed-link" v-html="$t('cookies.change_settings_to_watch_video_adblock')"></button>
    </div>
    <div v-if="consent">
      <div v-if="videoProviderData.type == 'youtube'" ref="player" class="plyr plyr__video-embed m-video-player__player">
        <iframe :src="'https://www.youtube.com/embed/' + videoProviderData.id + '?origin=' + origin + '&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1'" allowfullscreen allowtransparency allow="autoplay"></iframe>
      </div>
      <div v-if="videoProviderData.type == 'vimeo'" ref="player" class="plyr plyr__video-embed m-video-player__player">
        <iframe :src="'https://player.vimeo.com/video/' + videoProviderData.id + '?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media&amp;autoplay=' + autoplay" allowfullscreen allowtransparency allow="autoplay"></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import 'plyr/dist/plyr.css'
import Plyr from 'plyr'
import { useCookiebot } from '../js/cookiebot'

const cookiebot = useCookiebot();

export default {
  props: {
    url: {
      type: String,
      required: true,
    },

    autoplay: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    origin: null,
    videoProviderData: null,
    plyr: null,
    consentOverride: false,
    cookiebot: cookiebot,
  }),

  computed: {
    consent() {
      return cookiebot.marketing.value || this.consentOverride;
    },
  },

  created() {
    this.origin = location.origin;
    this.videoProviderData = this.parseVideo(this.url);
  },

  watch: {
    consent(value) {
      if (value) {
        this.$nextTick(() => {
          this.init();
        });
      }
    },
  },

  mounted() {
    if (this.consent) {
      this.$nextTick(() => {
        this.init();
      });
    }
  },

  methods: {
    init() {
      this.plyr = new Plyr(this.$refs.player, {
        fullscreen: {
          enabled: true,
          fallback: true,
          iosNative: true,
        },
        youtube: {
          noCookie: true,
        },
        vimeo: {
          dnt: true,
        },
        controls: [(this.autoplay ? null : "play-large"), "play", "progress", "current-time", "mute", "volume", "captions", "fullscreen"],
        storage: {
          enabled: false,
        },
      });

      if (this.autoplay) {
        this.plyr.on('ready', () => {
          this.plyr.play();
        });
      }
    },

    stop() {
      this.plyr.pause();
    },

    parseVideo(url) {
      var type = null;
      // - Supported YouTube URL formats:
      //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
      //   - http://youtu.be/My2FRPA3Gf8
      //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
      // - Supported Vimeo URL formats:
      //   - http://vimeo.com/25451551
      //   - http://player.vimeo.com/video/25451551
      // - Also supports relative URLs:
      //   - //player.vimeo.com/video/25451551
      url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);
      if (RegExp.$3.indexOf("youtu") > -1) {
        type = "youtube";
      } else if (RegExp.$3.indexOf("vimeo") > -1) {
        type = "vimeo";
      }
      return {
        type: type,
        id: RegExp.$6,
      };
    },
  },
};
</script>
